import { apiFetch } from './auth-service';

export interface PhaseDoc {
  _id: string;
  order: number;
  title: string;
  description: string;
  type: string;
  courseIds: string[];
}

export const getPhases = async (): Promise<PhaseDoc[]> => {
  const r = await apiFetch.get<{ phases: PhaseDoc[] }>('/phases');
  return r.phases;
};

export const createPhase = async (data: {
  title: string; description?: string; courseIds?: string[];
}): Promise<PhaseDoc> => {
  const r = await apiFetch.post<{ phase: PhaseDoc }>('/phases', data);
  return r.phase;
};

export const updatePhase = async (id: string, data: Record<string, any>): Promise<PhaseDoc> => {
  const r = await apiFetch.put<{ phase: PhaseDoc }>(`/phases/${id}`, data);
  return r.phase;
};

export const deletePhase = async (id: string): Promise<void> => {
  await apiFetch.delete(`/phases/${id}`);
};

export const reorderPhases = async (order: { id: string; order: number }[]): Promise<PhaseDoc[]> => {
  const r = await apiFetch.post<{ phases: PhaseDoc[] }>('/phases/reorder', { order });
  return r.phases;
};

// ── Founder-side progress ─────────────────────────────────────────────

export interface PhaseProgressEntry {
  phaseId: string;
  order: number;
  title: string;
  description: string;
  courseIds: string[];
  status: 'locked' | 'active' | 'completed';
  completedAt: string | null;
  lockReason?: string | null;
}

export const getMyProgress = async (): Promise<PhaseProgressEntry[]> => {
  const r = await apiFetch.get<{ progress: PhaseProgressEntry[] }>('/phases/my-progress');
  return r.progress;
};

export const markPhaseComplete = async (phaseId: string): Promise<PhaseProgressEntry[]> => {
  const r = await apiFetch.post<{ progress: PhaseProgressEntry[] }>(`/phases/${phaseId}/complete`);
  return r.progress;
};
